import { useState, useEffect, ReactNode } from 'react'
import { Button } from "react-bootstrap";
import ConsoleNavMenu from './console/ConsoleNavMenu';
import { APIRequestGet, APIRequestPost } from '../utils/APIRequests';
import { AdminSwitchToUserRequestData, UserEmailListSchema } from '../api/Admin';

function Users(): ReactNode {
    const [users, setUsers] = useState<string[]>([]);

    useEffect(() => {
        getAllUsers();

        console.log("users mount");
        return () => {
            console.log("users unmount");
        };
    }, []);

    function getAllUsers(): void {
        APIRequestGet('/admin/getAllUsers', {
            schema: UserEmailListSchema,
            logSuccess: true
        }).then((result) => {
            setUsers(result.data.users);
        });
    }

    function switchToUser(user: string): void {
        const data: AdminSwitchToUserRequestData = { user };

        APIRequestPost('/admin/switchToUser', {
            data: data,
            logSuccess: true
        }).then(() => {
            window.location.href = "/";
        });
    }

    return (
        <>
            <ConsoleNavMenu />
            <div className='max-width text-page-padding users-list'>
                {users.map(user =>
                    <div className='user-button' key={user}>
                        <Button onClick={() => switchToUser(user)}>{user}</Button>
                    </div>
                )}
            </div>
        </>

    )
}

export default Users;